<template>
  <div
    class="d-flex-column justify-start align-start gap-20"
    style="margin-top: 36px"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t("new.difficulty") }}
    </h4>

    <div
      class="d-flex-row justify-start platform_picker_container md-row-to-col"
    >
      <button
        class="role_picker d-flex-row flex-33 gap-5 medium-l font-family-2"
        v-for="option in difficultyOptions"
        :key="option"
        :class="[
          isOptionSelected(option.id) && 'selected',
          isDisabled(option) && 'disabled',
        ]"
        @click.stop="selectOption(option)"
      >
        <img
          :src="`/images/games/path-of-exile-2-boost/options/${option.const_title}.webp`"
          height="26"
          width="26"
        />
        {{ option.title }}
        <span class="t-blue"> {{ renderPrice(option) }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { calculateCurrency } from "~/calculate/calculatePrice";
const gameStore = useGameStore();
const userStore = useUserStore();
const checkoutStore = useCheckoutStore();
const difficultyOptions = computed(() => {
  const options =
    gameStore.getGamePack?.pack_options?.filter(
      (op) =>
        op.const_title === "hard_core" ||
        op.const_title === "soft_core" ||
        op.const_title === "ssf_soft_core"
    ) || [];
  return options;
});

const isOptionSelected = (packOption) => {
  const selectedOption = checkoutStore.getPackOptions.find(
    (option) => option === packOption
  );
  if (!selectedOption) {
    return false;
  }
  return true;
};

const selectOption = (option) => {
  if (!isOptionSelected(option.id)) {
    checkoutStore.removePackOption({
      optionIds: option?.rules?.disable || [],
    });
    let assign = [];

    if (option.rules?.assign) {
      assign = [option.rules.assign[0]];
    }

    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, option.id, ...assign],
    });
  } else if (checkoutStore.getPackOptions?.length > 1) {
    const otherOptions = checkoutStore.getPackOptions.filter(
      (packOpt) => packOpt !== option.id
    );

    checkoutStore.setPackOptions({
      options: [...otherOptions],
    });
  }
};
const isDisabled = (option) => {
  const isSelected = checkoutStore.getPackOptions?.some((op) =>
    difficultyOptionsOther.value.includes(op)
  );
  if (option.const_title === "soft_core") return false;
  if (option.const_title === "ssf_soft_core") {
    return isSelected;
  }
  if (option.const_title === "hard_core") {
    return isSelected;
  }
  return false;
};

const difficultyOptionsOther = computed(() => {
  return gameStore.getGamePack.pack_options
    ?.filter(
      (op) =>
        op.const_title === "self_play" || op.const_title === "remote_control"
    )
    .map((op) => op.id);
});
const renderPrice = (packOption) => {
  if (packOption.type === "free") {
    return "";
  } else if (packOption.type === "variable") {
    return `+${packOption.price}%`;
  } else if (packOption.type === "fixed") {
    return `+${parseFloat(calculateCurrency(packOption.price)).toFixed(2)}${
      userStore.getUserCurrencyCode
    }`;
  } else {
    return `+${packOption.price}`;
  }
};
// const selectDifficulty = (optionId) => {
//   checkoutStore.setDifficulty(optionId);
// };
</script>
